/**
 * Shared theme-related components for SMFA
 */

/**
 * Color palette based on existing application colors
 * @param {string} mode - "light"|"dark"
 * @returns {Object} designTokens - The design tokens for the current theme
 */
export const getDesignTokens = (mode) => ({
  palette: {
    mode,
    primary: {
      main: "#0cb8b6", // Teal color used throughout the app
      light: "#5eeae8",
      dark: "#008886",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#E29A12", // Orange/amber color used in pagination etc
      light: "#ffcb43",
      dark: "#ac6c00",
      contrastText: "#000000",
    },
    error: {
      main: "#d32f2f",
    },
    warning: {
      main: "#ff9800",
    },
    info: {
      main: "#0288d1",
    },
    success: {
      main: "#2e7d32",
    },
    background: {
      default: mode === "light" ? "#f5f7fa" : "#121212",
      paper: mode === "light" ? "#ffffff" : "#1e1e1e",
    },
    text: {
      primary: mode === "light" ? "#333333" : "#ffffff",
      secondary: mode === "light" ? "#666666" : "#aaaaaa",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 500,
    },
    h2: {
      fontWeight: 500,
    },
    button: {
      textTransform: "none",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "4px",
        },
        contained: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "standard",
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
  },
});
